import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-download-circle',
	templateUrl: './icon-download-circle.component.svg',
})
export class IconDownloadCircleComponent {}
